import React from 'react';
import {Button, withStyles,} from '@material-ui/core';
import {NextArrow} from "../../../../../../helpers/Icons";
import {formatDateTime} from "./colorUtils";

const styles = {
  response:{
    margin: "0 auto",
  },
  responseText:{
    textAlign: "center",
    fontWeight: 300,
    margin: "0.5rem 0"
  },
  optionsLabels:{
    fontSize: "0.7225rem",
    fontWeight: 500,
    '& > td':{
      textAlign: "center",
      verticalAlign: "top",
      width: "33%"
    },
    '& > td:first-child':{
      textAlign: "left"
    },
    '& > td:last-child':{
      textAlign: "right"
    },
  },
  nextOpts: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
  },
  nextBtn: {
    width: "351px",
    height: "34px"
  },
  dateContainer: {
    // fontSize: "0.7225rem",
    display: "flex",
    gap: "0.35em"
    // flexDirection: "column",
  },
}
function NextButton(props) {
  const { nextQuestion, answerDate, disabled=false, classes } = props;

  return (
    <div className={classes.response}>
      <div className={classes.responseText}>&nbsp;</div>
      <div className={classes.options}>
        <table>
          <tbody>
          <tr>
            <td colSpan={2}>
              <div className={classes.nextOpts}>
                <Button
                  id="nextQuestion"
                  disabled={disabled}
                  onClick={nextQuestion}
                  variant="contained" color="primary" endIcon={<NextArrow />}
                  className={classes.nextBtn}
                >Next Question</Button>
              </div>
            </td>
          </tr>
          <tr className={classes.optionsLabels}>
            <td>
              <div className={classes.dateContainer}>
                <span style={{fontSize: "0.85em", fontWeight: 600, textTransform: "uppercase"}}>Answered:</span>
                <span id={"answeredDate"}>{formatDateTime(answerDate)}</span>
              </div>
            </td>
            <td><br/><br/></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>)
}

export default withStyles(styles)(NextButton);